import {
  LayoutDashboard, Gem, Heart, Building2, Users, ListTodo, Clock,
  Wallet, ReceiptText, Package, FolderOpen, Handshake,
  BarChart3, Settings, TrendingUp, Stamp,
} from "lucide-react";

export const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/business", label: "Business", icon: TrendingUp, minLevel: 3 },
  { to: "/events", label: "Events", icon: Gem },
  { to: "/clients", label: "Clients", icon: Heart },
  { to: "/vendors", label: "Vendors", icon: Building2 },
  { to: "/team", label: "Team", icon: Users },
  { to: "/activity", label: "Activity", icon: ListTodo },
  { to: "/rundown", label: "Rundown", icon: Clock },
  { to: "/payments", label: "Payments", icon: Wallet },
  { to: "/invoices", label: "Invoices", icon: ReceiptText },
  { to: "/receipts", label: "Kuitansi", icon: Stamp, minLevel: 4 },
  { to: "/packages", label: "Packages", icon: Package },
  { to: "/documents", label: "Documents", icon: FolderOpen },
  { to: "/meetings", label: "Meetings", icon: Handshake },
  { to: "/reports", label: "Reports", icon: BarChart3, minLevel: 2 },
  { to: "/settings", label: "Settings", icon: Settings, minLevel: 3 },
];

export const ROLE_LEVEL = { owner: 4, admin: 4, manager: 3, coordinator: 1, crew: 1, staff: 1, client: 0 };

export const roleHome = (role) => role === "client" ? "/portal" : (role === "crew" ? "/crew" : "/dashboard");

export const ROLE_LABEL = { owner: "Owner", admin: "Owner", manager: "Manager", crew: "Crew", coordinator: "Crew", staff: "Crew", client: "Client" };

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/primrose.organizer?igsh=MTNuazFxMmVqejl5MQ%3D%3D&utm_source=qr" },
  { name: "TikTok", url: "https://www.tiktok.com/@primrose.organizer" },
  { name: "Threads", url: "https://www.threads.com/@primrose.organizer" },
];

export const STATUS_COLORS = {
  DONE: "bg-emerald-100 text-emerald-700 border-emerald-200",
  "IN PROGRESS": "bg-blue-100 text-blue-700 border-blue-200",
  "IN_PROGRESS": "bg-blue-100 text-blue-700 border-blue-200",
  REVIEW: "bg-violet-100 text-violet-700 border-violet-200",
  TODO: "bg-amber-100 text-amber-700 border-amber-200",
  PENDING: "bg-amber-100 text-amber-700 border-amber-200",
  Pending: "bg-amber-100 text-amber-700 border-amber-200",
  OVERDUE: "bg-red-100 text-red-700 border-red-200",
  CANCELLED: "bg-gray-100 text-gray-600 border-gray-200",
  Cancelled: "bg-gray-100 text-gray-600 border-gray-200",
  PAID: "bg-emerald-100 text-emerald-700 border-emerald-200",
  PARTIAL: "bg-amber-100 text-amber-700 border-amber-200",
  UNPAID: "bg-red-100 text-red-700 border-red-200",
  Active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  CONFIRMED: "bg-emerald-100 text-emerald-700 border-emerald-200",
  "NOT CONFIRMED": "bg-amber-100 text-amber-700 border-amber-200",
  ARRIVED: "bg-blue-100 text-blue-700 border-blue-200",
  COMPLETED: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Attending: "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Not Attending": "bg-red-100 text-red-700 border-red-200",
  Maybe: "bg-amber-100 text-amber-700 border-amber-200",
  "No Response": "bg-gray-100 text-gray-600 border-gray-200",
  Lead: "bg-gray-100 text-gray-600 border-gray-200",
  Consultation: "bg-blue-100 text-blue-700 border-blue-200",
  Negotiation: "bg-violet-100 text-violet-700 border-violet-200",
  Booked: "bg-gold/20 text-gold-dark border-gold/40",
  Preparation: "bg-blue-100 text-blue-700 border-blue-200",
  Event: "bg-burgundy/10 text-burgundy border-burgundy/20",
  Completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Done: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Scheduled: "bg-blue-100 text-blue-700 border-blue-200",
  Draft: "bg-gray-100 text-gray-600 border-gray-200",
  Dikirim: "bg-blue-100 text-blue-700 border-blue-200",
  "Sebagian Dibayar": "bg-amber-100 text-amber-700 border-amber-200",
  Lunas: "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Jatuh Tempo": "bg-red-100 text-red-700 border-red-200",
  Dibatalkan: "bg-gray-100 text-gray-600 border-gray-200",
  Diterbitkan: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const PRIORITY_COLORS = {
  LOW: "bg-gray-100 text-gray-600",
  MEDIUM: "bg-blue-100 text-blue-700",
  HIGH: "bg-amber-100 text-amber-700",
  URGENT: "bg-red-100 text-red-700",
};

export const CLIENT_STATUSES = ["Lead", "Consultation", "Negotiation", "Booked", "Preparation", "Event", "Completed", "Cancelled"];
export const EVENT_STATUSES = ["Booked", "Preparation", "In Progress", "Completed", "Cancelled"];
export const VENDOR_CATEGORIES = ["Venue", "Catering", "Decoration", "MUA", "Photography", "Videography", "Entertainment", "MC", "Attire / Busana", "Invitation", "Souvenir", "Wedding Cake", "Transportation", "Lighting", "Sound System", "Others"];
export const TEAM_ROLES = ["Owner", "Manager", "Coordinator", "Crew", "Runner", "Usher", "Admin"];
export const TASK_STATUSES = ["TODO", "IN PROGRESS", "REVIEW", "DONE"];
export const CHECKLIST_STATUSES = ["TODO", "IN PROGRESS", "DONE", "OVERDUE"];
export const CHECKLIST_CATEGORIES = ["CLIENT", "VENUE", "DECORATION", "CATERING", "DOCUMENTATION", "CEREMONY"];
export const PRIORITIES = ["LOW", "MEDIUM", "HIGH", "URGENT"];
export const RSVP_STATUSES = ["Attending", "Not Attending", "Maybe", "No Response"];
export const PAYMENT_STATUSES = ["PAID", "PARTIAL", "UNPAID", "OVERDUE"];
export const DOC_TYPES = ["Contract", "Invoice", "Proposal", "Rundown", "Vendor Contract", "Floor Plan", "Guest List", "Technical Meeting", "Client Brief", "Other"];
export const MEETING_TYPES = ["Technical Meeting", "Vendor Meeting", "Client Meeting", "Internal Meeting"];
export const CONFIRMATION_STATUSES = ["NOT CONFIRMED", "CONFIRMED", "ARRIVED", "COMPLETED"];

export const INVOICE_STATUSES = ["Draft", "Dikirim", "Sebagian Dibayar", "Lunas", "Jatuh Tempo", "Dibatalkan"];

export const APP_LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_primrose-planner/artifacts/av1ubaxa_IMG_0471.webp";

export const fmtIDR = (n) =>
  "Rp " + Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(String(d).slice(0, 10) + "T00:00:00").toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  } catch { return String(d); }
};

export const daysUntil = (d) => {
  if (!d) return null;
  const target = new Date(String(d).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / 86400000);
};
